import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { bindActionCreators } from "redux";
import { userUpdateAction } from "../../../modules/userManagement/action";
import AllUsersForm from "./AllUsersForm";

//Started working on update plan

class EditAnyUser extends Component {
  state = {
    successMessage: false
  };

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.userUpdated &&
      nextProps.userUpdated !== this.props.userUpdated &&
      nextProps.userUpdated.status === 200
    ) {
      this.setState({ successMessage: true });
    }
  }

  handleSubmit = userInfo => {
    userInfo.id = this.props.selectedUser.id;
    userInfo.farmId = this.props.selectedUser.farmResponseDTO.id;
    delete userInfo.password;
    this.props.userUpdateAction(userInfo);
  };

  render() {
    const { successMessage } = this.state;
    if (successMessage) {
      return <Redirect to="/usermanagement" />;
    }
    return (
      <AllUsersForm
        editMode={true}
        buttonLabel="Update"
        formLabel="Edit user details"
        SubFarmId={this.props.SubFarmId}
        userInfo={this.props.selectedUser}
        handleSubmit={this.handleSubmit}
        MainFarmId={this.props.MainFarmId}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    selectedUser: state.userManagementReducer.selectedUser,
    userUpdated: state.userManagementReducer.userUpdated,
    SubFarmId: state.FarmManagementReducer.SubFarmId,
    MainFarmId: state.FarmManagementReducer.MainFarmId
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators({ userUpdateAction }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditAnyUser);



// WEBPACK FOOTER //
// ./src/components/private/UserManagement/EditAnyUser.js